import { Transforms } from 'slate';
import type { Path } from 'slate';
import type { SlateEditor, TElement } from 'platejs';

import {
    asEditor,
    isUrl,
} from 'common/components/ContentEditor/utils/editorHelpers';
import { options } from 'common/components/ContentEditor/options';
import { sanitizeIframeHtml } from 'common/components/Embed';

export interface IEmbedValue {
    url?: string;
    html?: string;
}

/** Accepts either a URL or raw `<iframe>` code, returning the value to store, or `undefined` if neither is valid. */
export const parseEmbedInput = (input: string): IEmbedValue | undefined => {
    const trimmed = input.trim();
    const html = sanitizeIframeHtml(trimmed);

    if (html) return { html };
    if (isUrl(trimmed)) return { url: trimmed };

    return undefined;
};

export const getEmbedNode = (editor: SlateEditor) =>
    editor.api.block({ match: { type: options.media_embed.type } });

export const insertEmbed = (editor: SlateEditor, value: IEmbedValue) => {
    const embed = {
        type: options.media_embed.type,
        ...value,
        children: [{ text: '' }],
    };

    Transforms.insertNodes(asEditor(editor), embed as TElement);
};

export const replaceEmbed = (
    editor: SlateEditor,
    at: Path,
    value: IEmbedValue
) => {
    const slateEditor = asEditor(editor);

    Transforms.unsetNodes(slateEditor, ['url', 'html'], { at });
    Transforms.setNodes(slateEditor, value as Partial<TElement>, { at });
};
